<template>
  <div class="themeArticleDetail2"
       :class="IsPC?'pcStyle':''">
    <div class="dormListContainer"
         :style="isShowNotic ? {height: 'calc(100vh - 50px)'} : ''">
      <cube-scroll v-if="isDormList"
                   ref="scroll"
                   :data="dormList"
                   :scrollEvents="['scroll']"
                   @scroll="scrollEnd"
                   @pulling-down="onPullingDown"
                   @pulling-up="onPullingUp"
                   :options="options">
        <div class="listClass">
          <div class="dormItem"
               v-for="item in dormList"
               :key="item.id"
               @click="turnToDormDetail(item)">
            <div class="itemTop">
              <img :src="item.articlePic"
                   alt="">
            </div>
            <div class="itemBottom">
              <span>{{ item.name }}</span>
            </div>

          </div>
        </div>
      </cube-scroll>
      <div class="noDormList"
           v-else>
        <div class="noDormListImg">
          <img src="img/nodata.png"
               alt />
        </div>
        <div class="sorryWord">{{failNotice}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      html: '',
      contentStr: '',
      pullDownRefreshObj: {
        threshold: 90,
        stop: 40,
        txt: '刷新成功'
      },
      pullUpLoadObj: {
        threshold: 0,
        txt: {
          more: '上拉加载更多',
          noMore: '没有更多数据'
        } // 配置上拉加载
        // visible: true
      },
      startY: 0,
      isShowNotic: false,
      isDormList: true,
      failNotice: '暂无数据',
      noMoreData: false,
    }
  },
  async created () {
    document.title = '历史专题'
     await this.$store.dispatch('login', { Vm: this });
    if (this.$store.state.DormitoryList === null) {
      await this.themeArticleHistory()
    } else {
      setTimeout(() => {
        this.$nextTick(() => {
          if (this.$store.state.positionObj && this.$store.state.positionObj.y !== 0) {
            this.$refs.scroll.scrollTo(0, this.$store.state.positionObj.y + 60, 700)
          }
        })
      }, 300)
    }
  },
  mounted () {
    if (this.environment.isFengChao) {
      setTimeout(() => {
        this.$cjc.showNavigation()
      }, 500);
    }
  },
  computed: {
    dormList () {
      try {
        return this.$store.state.DormitoryList
      } catch (Error) {
        return []
      }
    },
    userInfo () {
      return this.$store.state.userInfo
    },
    IsPC () {
      var userAgentInfo = navigator.userAgent;
      var Agents = ['Android', 'iPhone',
        'SymbianOS', 'Windows Phone',
        'iPad', 'iPod'
      ];
      var flag = true;
      for (var i = 0; i < Agents.length; i++) {
        if (userAgentInfo.indexOf(Agents[i]) != -1) {
          flag = false;
          break;
        }
      }
      return flag
    },
    options () {
      return {
        pullUpLoad: this.pullUpLoadObj, // 上拉加载 若要关闭可直接 pullUpLoad：false
        pullDownRefresh: this.pullDownRefreshObj, // 下拉刷新
        startY: this.startY, // 初始滚动位置
        useTransition: false
      }
    },
  },
  methods: {
    turnToDormDetail (item) {
      console.log(item);
      if (item.articleType == 1) {
        this.$router.push({ name: 'ProjectDetails', query: { id: item.id, name: item.name } })
      } else if (item.articleType == 2) {
        let content = JSON.parse(item.content)
        console.log(content);
        if (this.environment.isFengChao) {
          this.isApiAppOpenService = false;
          this.$cjc.apiAppOpenService({
            openType: 2,
            extinfo: {
              mpId: content.imId,
              mpName: content.nickname
            }
          });
          setTimeout(() => {
            this.isApiAppOpenService = true;
          }, 1000);
        } else {
          this.$Message.error(`请在${this.APPName}上打开`);
        }
        //
      } else if (item.articleType == 3) {
        // let content = JSON.parse(item.content)
        if (this.environment.isFengChao) {
          this.$cjc.openNewWebView({
            'url': item.content,
            'title': item.name,
            'hiddenNavigation': false
          })
        } else {
          this.$Message.error(`请在${this.APPName}上打开`);
        }

      }
      // 
    },
    scrollEnd (obj) {
      this.$store.commit('SET_positionObj', obj)
    },
    onPullingDown () {
      this.$store.commit('SET_DormitoryList', null)
      this.$store.commit('SET_pageIndex', 1)
      this.themeArticleHistory()
    },
    onPullingUp () {
      if (!this.noMoreData) {
        let page = this.$store.state.pageIndex
        console.log(page)
        page++
        this.$store.commit('SET_pageIndex', page)
        this.themeArticleHistory()
      } else {
        this.$refs.scroll.forceUpdate()
      }
    },
    async themeArticleHistory () {
      console.log(this.userInfo, '123asdada12');
      const { data: { result, status,msg } } = await this.$store.dispatch('themeArticleHistory', {
        userId: 1,
        // userId: this.userInfo.USER_ID,
        pageIndex: this.$store.state.pageIndex,
        pageSize: 9,
      })
      console.log(result,status);
      if (status === 1000) {
        this.$store.commit('SET_DormitoryList', result.dataList)
        if (this.$store.state.DormitoryList.length == 0) {
          this.isDormList = false
        }
        if (result.dataList.length < 9) {
          this.noMoreData = true
        } else {
          this.noMoreData = false
        }
        if (this.$store.state.pageIndex === 1) {
          this.$nextTick(() => {
            this.$refs.scroll.scrollTo(0, 0, 700)
          })
        }
      } else {
        this.$store.commit('SET_DormitoryList', null)
        this.isDormList = false
        // this.failNotice = res.data.msg
        this.$refs.scroll.forceUpdate()
        this.$Message.error(msg)
      }
    },
  },
}
</script>

<style lang="scss" >
@import "@/styles/wangEditor/index.scss";
.themeArticleDetail2 {
  box-sizing: border-box;
  background-color: #fff;
  width: 100%;
  height: 100%;
  .dorm-pro {
    // margin-top: 5px;
    padding-right: 8px;
    cursor: pointer;
    img {
      width: 24px;
      height: 24px;
    }
  }
  .refresh-area {
    // margin-top: 5px;
    padding-right: 15px;
    cursor: pointer;
    img {
      width: 20px;
      height: 20px;
    }
  }
  @keyframes rotation {
    from {
      -webkit-transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  .Rotation {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    animation: rotation 0.8s linear infinite;
    -moz-animation: rotation 0.8s linear infinite;
    -webkit-animation: rotation 0.8s linear infinite;
    -o-animation: rotation 0.8s linear infinite;
  }
  .headTip {
    width: 100%;
    // position: fixed;
    position: relative;
    word-break: break-all;
    // top: 50px;
    background-color: #ffffff;
    margin: 12px 0 0;
    line-height: 20px;
    color: #7a7b7d;
    .ci-notice .icon {
      font-size: 18px;
    }
    .text-content {
      font-size: 12px;
    }
  }
  .dormListContainer {
    height: calc(100vh - 50px);
    bottom: 0;
    width: 100%;
    .listClass {
      padding: 8px;
      // margin: 0 auto;
      .dormItem {
        cursor: pointer;
        overflow: hidden;
        border-radius: 7px;
        display: inline-block;
        // vertical-align: middle;
        background-color: #fff;
        // border: 1px solid #efeff4;
        margin: 5px 2%;
        width: 96%;
        text-align: left;
        padding: 12px;
        box-shadow: 0px 4px 20px rgba(42, 42, 42, 0.08);

        .itemTop {
          height: 150px;
          width: 100%;
          padding-bottom: 12px;
          border-bottom: 1px solid #f5f5f5;
          & > img {
            width: 100%;
            height: 100%;
          }
        }
        .itemBottom {
          padding: 6px 0px 0;
          & > span {
            font-size: 15px;
            color: #1a1a1a;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }
        }
      }
    }
    .noDormList {
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      text-align: center;
      .sorryWord {
        font-size: 12px;
        color: #aeaeb4;
        line-height: 24px;
        padding: 16px;
      }
      .noDormListImg {
        width: 100%;
        img {
          width: 100px;
          // height: 100px;
        }
      }
    }
  }
}
</style>
